export default "__VITE_ASSET__915134cf__"